module.exports = new __parcel__URL__("lost-in-translation.8daaa1e9.jpg").toString();